"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var _SharedBox_mainKey;
var SharedBox_1;
Object.defineProperty(exports, "__esModule", { value: true });
exports.SharedBox = void 0;
const unicrypto_1 = require("unicrypto");
const AnnotatedKey_1 = require("./AnnotatedKey");
const uparsecjs_1 = require("uparsecjs");
const AnnotatedKeyring_1 = require("./AnnotatedKeyring");
const MapSerializer_1 = require("./MapSerializer");
/**
 * Shared box allow encrypt its content with any number of keys so any of them allow to access its content.
 * It is possible to add more keys to existing SharedBox if it is new or unlocked.
 */
let SharedBox = SharedBox_1 = class SharedBox {
    constructor(accessors, encryptedPayload) {
        this.accessors = accessors;
        this.encryptedPayload = encryptedPayload;
        this.packedAccessors = new Map();
        _SharedBox_mainKey.set(this, void 0);
        for (const { annotation, encryptedKey } of accessors) {
            this.packedAccessors.set(AnnotatedKey_1.annotationLabel(annotation), encryptedKey);
        }
    }
    get accessKey() {
        if (!__classPrivateFieldGet(this, _SharedBox_mainKey, "f"))
            throw new Error("SafeBox is not unlocked/initialized");
        return __classPrivateFieldGet(this, _SharedBox_mainKey, "f");
    }
    initializeAsNew() {
        if (__classPrivateFieldGet(this, _SharedBox_mainKey, "f") || this.packedAccessors.size > 0)
            throw new Error("SharedBox is already initialized");
        __classPrivateFieldSet(this, _SharedBox_mainKey, new unicrypto_1.SymmetricKey(), "f");
        return this;
    }
    async addKeys(...keys) {
        if (!__classPrivateFieldGet(this, _SharedBox_mainKey, "f"))
            throw new Error("SharedBox is not initialized");
        for (const key of keys) {
            const ek = await key.etaEncrypt(__classPrivateFieldGet(this, _SharedBox_mainKey, "f").pack());
            this.packedAccessors.set(key.annotationLabel, ek);
            this.accessors.push({ annotation: key.annotation, encryptedKey: ek });
        }
        return this;
    }
    get payloadPromise() {
        if (!this._cachedPayload) {
            if (this.encryptedPayload)
                this._cachedPayload = this.accessKey.etaDecrypt(this.encryptedPayload);
            else
                throw new Error("SharedBox has no payload");
        }
        return this._cachedPayload;
    }
    /**
     * Await and deserialize payload (that should be [MapSerializer] serialized therefore).
     */
    async deserialize() {
        return await MapSerializer_1.MapSerializer.anyFromBoss(await this.payloadPromise);
    }
    async setPayload(value) {
        if (!(this._cachedPayload !== undefined && uparsecjs_1.equalArrays(value, await this._cachedPayload))) {
            if (!__classPrivateFieldGet(this, _SharedBox_mainKey, "f"))
                throw new Error("SharedBox is not initialized");
            this.encryptedPayload = await __classPrivateFieldGet(this, _SharedBox_mainKey, "f").etaEncrypt(value);
            this._cachedPayload = Promise.resolve(value);
        }
        return this;
    }
    /**
     * Unlock the shared box using keys from a ring or throw exception.
     * @param keyRing where to get keys to try
     * @return self, unlocked
     * @throws SharedBox.Exception if no one key in the ring opens the box
     */
    async unlockWithRing(keyRing) {
        if (__classPrivateFieldGet(this, _SharedBox_mainKey, "f"))
            throw new Error("SharedBox already unlocked");
        const annotations = this.accessors.map(k => k.annotation);
        const key = await keyRing.findKey(...annotations);
        if (!key)
            throw new SharedBox_1.Exception("can't unlock");
        const packed = this.packedAccessors.get(key.annotationLabel);
        if (!packed)
            throw new Error("inconsistent SharedBox state (internal error)");
        __classPrivateFieldSet(this, _SharedBox_mainKey, new unicrypto_1.SymmetricKey({
            keyBytes: await key.etaDecrypt(packed)
        }), "f");
        return this;
    }
    /**
     * Unlock the shared box using keys from a ring or throw exception.
     * @param keys to try to unlock with
     * @return self, unlocked
     * @throws SharedBox.Exception if no one key in the ring opens the box
     */
    async unlockWithKeys(...keys) {
        return this.unlockWithRing(new AnnotatedKeyring_1.AnnotatedKeyring().addKeys(...keys));
    }
    async toMap() {
        const sa = new Map();
        for (const a of this.accessors)
            sa.set(AnnotatedKey_1.serializeKeyAnnotation(a.annotation), a.encryptedKey);
        return {
            packedAccessors: sa,
            encryptedPayload: this.encryptedPayload
        };
    }
    async pack() {
        return unicrypto_1.Boss.dump(await this.toMap());
    }
    static async fromMap(source) {
        const sourceAccessors = source.packedAccessors;
        const accessors = Array();
        for (const [k, v] of sourceAccessors) {
            // packed key annotation is not exactly in our native format
            accessors.push({ annotation: AnnotatedKey_1.deserializeKeyAnnotation(k), encryptedKey: v });
        }
        return new SharedBox_1(accessors, source.encryptedPayload);
    }
    static async unpack(source) {
        const x = await unicrypto_1.Boss.load(source);
        return this.fromMap(x);
    }
    static async createWith(payload) {
        return SharedBox_1.createWithPacked(await MapSerializer_1.MapSerializer.toBoss(payload));
    }
    static async createWithPacked(data) {
        const sb = new SharedBox_1([]);
        sb.initializeAsNew();
        await sb.setPayload(data);
        return sb;
    }
};
_SharedBox_mainKey = new WeakMap();
/**
 * It thrown when it is not possible to unlock the box with a given keyring
 */
SharedBox.Exception = class extends Error {
};
SharedBox = SharedBox_1 = __decorate([
    MapSerializer_1.Serializable
], SharedBox);
exports.SharedBox = SharedBox;
//# sourceMappingURL=SharedBox.js.map